import { render, staticRenderFns } from "./FeeTotal.vue?vue&type=template&id=154a799e&scoped=true&"
import script from "./FeeTotal.vue?vue&type=script&lang=js&"
export * from "./FeeTotal.vue?vue&type=script&lang=js&"
import style0 from "./FeeTotal.vue?vue&type=style&index=0&id=154a799e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154a799e",
  null
  
)

export default component.exports